import { Auth } from '@aws-amplify/auth';
import { API } from 'aws-amplify';
import { v4 } from 'uuid';
import { AccessTokenRevoked } from '../../../Authentication/authErrors';
import config from '../../../config';
import { endTransaction, startTransaction } from '../../../redux/actions/SystemActions';
import { systemStore } from '../../../redux/stores/SystemStore';
import { DebugAuth } from '../DebugAuth';
const debug = process.env.REACT_APP_DEBUG && false;
class ApiGateway {
    userInfo;
    getUserInfo = async () => {
        if (!this.userInfo) {
            this.userInfo = await Auth.currentUserInfo();
        }
        if (Object.keys(this.userInfo).length === 0) {
            debug && console.log('uh oh!', AccessTokenRevoked);
        }
        return this.userInfo;
    };
    post = async (path, body, apiRef = 'ConsumerApi') => {
        debug && console.log('API Post', { path, body, apiRef });
        let res = null;
        if (config.aws.amplify.logLevel === 'DEBUG')
            DebugAuth();
        try {
            const userInfo = await this.getUserInfo();
            debug && console.log('User Info', userInfo);
            const transactionId = v4();
            const t0 = Date.now();
            systemStore.dispatch(startTransaction({ apiRef, path, transactionId }));
            /**
             * Array predicate shim necessary as older request types like batchGet are plain arrays
             *
             * Also note: user is now extractable in API post change to HTTP API + context
             */
            if (!(body instanceof Array) && body?.requestingUser === undefined)
                body = { ...body, requestingUser: userInfo };
            const result = await API.post(apiRef, path, { body });
            systemStore.dispatch(endTransaction({ transactionId, durationMs: Date.now() - t0 }));
            debug && console.log(`${path} res`, { body, result }, { apiConfig: config.aws.apiConfigs });
            if (result) {
                if (typeof result.errorMessage === 'string') {
                    res = { err: { message: result.errorMessage }, data: null };
                }
                else {
                    res = result.body ?? result;
                }
            }
        }
        catch (e) {
            // TODO this function and its consumers ( all 100+ ) need to be converted to ErrData<AssertedReturnType>
            console.log(`API post caught`, e);
            console.log(`post details`, { path, apiConfig: config.aws.apiConfigs, apiRef });
            res = { err: new Error(e.message ?? e.errorMessage), data: null };
        }
        return res;
    };
    delete = async (path, body, apiRef = 'ConsumerApi') => {
        debug && console.log('API Delete', { path, body, apiRef });
        let res = null;
        if (config.aws.amplify.logLevel === 'DEBUG')
            DebugAuth();
        try {
            const userInfo = await this.getUserInfo();
            debug && console.log('User Info', userInfo);
            const transactionId = v4();
            const t0 = Date.now();
            systemStore.dispatch(startTransaction({ apiRef, path, transactionId }));
            /**
             * Array predicate shim necessary as older request types like batchGet are plain arrays
             *
             * Also note: user is now extractable in API post change to HTTP API + context
             */
            if (!(body instanceof Array) && body?.requestingUser === undefined)
                body = { ...body, requestingUser: userInfo };
            const result = await API.del(apiRef, path, { body });
            systemStore.dispatch(endTransaction({ transactionId, durationMs: Date.now() - t0 }));
            debug && console.log(`${path} res`, { body, result }, { apiConfig: config.aws.apiConfigs });
            if (result) {
                if (typeof result.errorMessage === 'string') {
                    res = { err: { message: result.errorMessage }, data: null };
                }
                else {
                    res = result.body ?? result;
                }
            }
        }
        catch (e) {
            // TODO this function and its consumers ( all 100+ ) need to be converted to ErrData<AssertedReturnType>
            console.log(`API delete caught`, e);
            console.log(`delete details`, { path, apiConfig: config.aws.apiConfigs, apiRef });
            res = { err: new Error(e.message ?? e.errorMessage), data: null };
        }
        return res;
    };
    get = async function apiGetMethod(path, queryStringParameters, apiRef = config.app.appName) {
        if (config.aws.amplify.logLevel === 'DEBUG')
            DebugAuth();
        let res = { err: null, data: null };
        debug && console.log('API GET', { path, queryStringParameters });
        const result = await API.get(apiRef, path, { queryStringParameters: queryStringParameters }).catch((e) => {
            console.log(e);
            return { err: e, data: null };
        });
        if (result) {
            if (typeof result.errorMessage === 'string') {
                res = { err: { message: result.errorMessage }, data: null };
            }
            else {
                res = result.body ?? result;
            }
        }
        console.log(`${path} res`, res);
        return res;
    };
}
export default new ApiGateway();
